import React from 'react';
import { Star } from 'lucide-react';
import { contactInfo } from '../data/mock';
import { track } from '../lib/analytics';

export const GoogleReviewCTA = ({ testIdPrefix = 'home-reviews' }) => {
  const url = contactInfo.googleReviewUrl;

  return (
    <section
      data-testid={`${testIdPrefix}-google-cta`}
      className="relative overflow-hidden"
      style={{ backgroundColor: '#0D0D0D', padding: '7rem 1.5rem' }}
    >
      <div className="absolute inset-0" style={{
        background: 'radial-gradient(ellipse at 50% 40%, rgba(194,168,120,0.05) 0%, transparent 55%)',
      }} />
      <div className="grain-overlay absolute inset-0" style={{ opacity: 0.03 }} />

      <div className="max-w-3xl mx-auto text-center relative z-10 fade-element">
        <div className="flex items-center justify-center" style={{ gap: '6px', marginBottom: '20px' }}>
          {[0, 1, 2, 3, 4].map((i) => (
            <Star key={`star-${i}`} size={18} strokeWidth={1.4} style={{ color: '#C2A878', fill: '#C2A878' }} />
          ))}
        </div>
        <p style={{ fontSize: '11px', color: 'rgba(194,168,120,0.55)', letterSpacing: '4px', textTransform: 'uppercase', fontWeight: 300, marginBottom: '18px' }}>
          Rated by Our Families
        </p>
        <h2 className="font-serif" style={{ fontSize: 'clamp(28px, 3.6vw, 42px)', fontWeight: 500, color: '#F5F5F5', marginBottom: '20px', lineHeight: 1.2 }}>
          Loved Your Journey? Share It on Google
        </h2>
        <p style={{ fontSize: '16px', color: 'rgba(225,225,225,0.7)', fontWeight: 300, lineHeight: 1.7, maxWidth: '520px', margin: '0 auto 44px' }}>
          Your words help other GTA families discover a chauffeur they can trust. It takes less than a minute.
        </p>

        <div className="flex flex-wrap items-center justify-center" style={{ gap: '16px' }}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${testIdPrefix}-leave-review-btn`}
            onClick={() => track('click_review_leave', { location: testIdPrefix })}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '10px',
              backgroundColor: '#C2A878', color: '#0A0A0A', padding: '15px 36px',
              fontSize: '12px', fontWeight: 500, letterSpacing: '1.2px', textTransform: 'uppercase',
              textDecoration: 'none', transition: 'all 400ms ease',
              boxShadow: '0 4px 24px rgba(194,168,120,0.15)',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#D4BA8A'; e.currentTarget.style.boxShadow = '0 6px 32px rgba(194,168,120,0.25)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#C2A878'; e.currentTarget.style.boxShadow = '0 4px 24px rgba(194,168,120,0.15)'; }}
          >
            <GoogleGlyph />
            Leave a Google Review
          </a>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={`${testIdPrefix}-read-reviews-btn`}
            onClick={() => track('click_review_read', { location: testIdPrefix })}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '10px',
              backgroundColor: 'transparent', color: '#C2A878', padding: '15px 36px',
              fontSize: '12px', fontWeight: 400, letterSpacing: '1.2px', textTransform: 'uppercase',
              border: '1px solid rgba(194,168,120,0.35)', textDecoration: 'none', transition: 'all 400ms ease',
            }}
            onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = 'rgba(194,168,120,0.08)'; e.currentTarget.style.borderColor = 'rgba(194,168,120,0.6)'; }}
            onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.borderColor = 'rgba(194,168,120,0.35)'; }}
          >
            Read Our Reviews on Google
          </a>
        </div>
      </div>
    </section>
  );
};

const GoogleGlyph = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#0A0A0A" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09Z" opacity="0.55" />
    <path fill="#0A0A0A" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.98.66-2.23 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z" opacity="0.8" />
    <path fill="#0A0A0A" d="M5.84 14.11a6.6 6.6 0 0 1 0-4.22V7.05H2.18a11 11 0 0 0 0 9.9l3.66-2.84Z" opacity="0.65" />
    <path fill="#0A0A0A" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.05L5.84 9.9C6.71 7.3 9.14 5.38 12 5.38Z" opacity="0.9" />
  </svg>
);
